import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'services';
import { IssueFeedbackService } from '../../../services/IssueFeedback.service';
import { IssueFeedback, IssueFeedbackTopic, IssueFeedbackType } from '../../../models/issue-feedback.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-issue-feedback',
  templateUrl: './issue-feedback.component.html',
  styleUrls: ['./issue-feedback.component.css']
})
export class IssueFeedbackComponent implements OnInit {
  @Output() hideIssueAndFeedback = new EventEmitter<boolean>();

  tabActive: string = '';
  isFormSubmited: boolean = false;
  activeTabId: number = null;
  issueFeedbackForm: FormGroup;
  issueFeedbackTypes: IssueFeedbackType[] = [];
  issueFeedbackTopics: IssueFeedbackTopic[] = [];
  isLoader: boolean = false;

  isError = false;
  selectedIssueFeedbackFiles: FileList | null = null;
  errorMessagesFileFormat = [];
  fileUploadValid = true;
  newUploadedIssueFeebackFile = [];
  fileId = 0;

  issueFeedbackFile: {
    id: number,
    file: File,
    fileName: string,
    size: any,
    errorMessagesFileFormat?: string, 
    errorMessagesFileSize?: string,
    errorMessagesFileType?: string
  }
  constructor(
    private sharedService: SharedService,
    private fb: FormBuilder,
    private issueFeedbackService: IssueFeedbackService, private router: Router
  ) {

    this.sharedService.tabChange$.subscribe(index => {
      this.tabActive = index;
      this.activeTabId = Number(index?.split('')[1]);
    });

    this.tabActive = localStorage.getItem('fs');
    this.activeTabId = Number(localStorage.getItem('fs').split('')[1]);
      // if(localStorage.hasOwnProperty('fs')){
      //   this.tabActive = localStorage.getItem('fs');
      //   this.activeTabId = 1;
      // }else{
      //   this.tabActive = '#2'
      //   this.activeTabId = 2;
      // }
    }

  ngOnInit(): void {
    this.initializeForm();
    this.loadIssueFeedbackTypes();
  }

  initializeForm(): void {
    this.issueFeedbackForm = this.fb.group({
      selectTopic: [null, Validators.required],
      describe: ['', [Validators.required, Validators.maxLength(1000)]],
      sendEmail: [false, Validators.required]
    });
  }

  loadIssueFeedbackTypes(): void {
    this.issueFeedbackService.getIssueFeedbackTypes().subscribe(
      (types: IssueFeedbackType[]) => {
        this.issueFeedbackTypes = types;
        if (types.length > 0) {
          // this.activeTabId = types[1].issueFeedbackTypeID;
          this.tabActive = `#${this.activeTabId}`;
          this.loadFeedbackTopics(this.activeTabId);
        }
      },
      (error) => {
        console.error('Error loading feedback types:', error);
      }
    );
  }

  getSelectedTab(event: any): void {
    this.isFormSubmited = false;
    this.tabActive = event.srcElement.hash || this.tabActive;
    this.activeTabId = Number(this.tabActive.substring(1));
    this.issueFeedbackForm.reset();

    if (this.activeTabId) {
      this.loadFeedbackTopics(this.activeTabId);
    }
    this.newUploadedIssueFeebackFile = [];
  }

  loadFeedbackTopics(issueFeedbackTypeId: number): void {
    this.issueFeedbackService.getIssueFeedbackTopicsByType(issueFeedbackTypeId).subscribe(
      (topics: IssueFeedbackTopic[]) => {
        this.issueFeedbackTopics = topics;
      },
      (error) => {
        console.error('Error loading feedback topics:', error);
      }
    );
  }

  closeIssueFeedback(): void {
    this.hideIssueAndFeedback.emit(false);
    if(localStorage.hasOwnProperty('fs')){
      localStorage.removeItem('fs');
    }
  }

  submit(): void {
    if (this.issueFeedbackForm.valid) {
      this.isLoader = true;
      this.isFormSubmited = true;
    //const issueFeedback = this.buildIssueFeedbackForm(); // Need to add Files, so taken formData

      const userId = this.sharedService.getValue('userId');
      const sendEmailValue = this.issueFeedbackForm.value.sendEmail === 'yes' ? true: false;

      const formData: FormData = new FormData();
      formData.append('issueFeedbackID', '0');
      formData.append('issueFeedbackTypeID', this.activeTabId.toString());
      formData.append('tenantId', this.sharedService.getValue('tenantId').toString());
      formData.append('topicID', this.issueFeedbackForm.value.selectTopic.toString());
      formData.append('description', this.issueFeedbackForm.value.describe);
      formData.append('sendEmail', sendEmailValue.toString());
      formData.append('receiverEmailId', this.sharedService.getValue('emailId'));
    
      if (this.newUploadedIssueFeebackFile) {
        for (let i = 0; i < this.newUploadedIssueFeebackFile.length; i++) {
          formData.append('files', this.newUploadedIssueFeebackFile[i].file, this.newUploadedIssueFeebackFile[i].fileName);
        }
      }

      this.issueFeedbackService.insertIssueFeedback(formData).subscribe(
        (response) => {
          //console.log('Issue feedback submitted successfully:', response);
          this.isLoader = false;
        },
        (error) => {
          console.error('Error submitting issue feedback:', error);
          this.isFormSubmited = false;
          this.isLoader = false;
        }
      );
    }
  }

  buildIssueFeedbackForm(): IssueFeedback {
    const tenantId = this.sharedService.getValue('tenantId');
    const userId = this.sharedService.getValue('userId');
    const sendEmailValue = this.issueFeedbackForm.value.sendEmail;

    return {
      issueFeedbackID: 0,
      issueFeedbackTypeID: this.activeTabId,
      tenantId: tenantId,
      topicID: this.issueFeedbackForm.value.selectTopic,
      description: this.issueFeedbackForm.value.describe,
      sendEmail: sendEmailValue === 'yes' ? true : false,
      ReceiverEmailId: this.sharedService.getValue('emailId'),
      ticketNumber: '',
      createdDate: null,
      createdBy: userId,
    };
  }

  selectFiles(event) {
    this.selectedIssueFeedbackFiles = event.target.files;
    this.getSelectedFiles(); 
    this.GetValidFiles();
  }

  private GetValidFiles() {
    this.isError = false;
    this.errorMessagesFileFormat = [];

    let isValid = true;
    this.fileUploadValid = true;
    let invalidFileFormat = [];
    let invalidFileSize = [];
    const supportedExt = "application/pdf, image/jpg, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"

    for (let i = 0; i < this.newUploadedIssueFeebackFile.length; i++) {
      let file = this.newUploadedIssueFeebackFile[i].file;

      let ext = file.type;
      let size = file.size;

      if (supportedExt.includes(ext)) {
        isValid = true;
        if (size > 10485760) {
          this.fileUploadValid = false;
          this.newUploadedIssueFeebackFile[i].errorMessagesFileSize = "Invalid file size! Max file size 10Mb"
        }
      } else {
        this.fileUploadValid = false;
        this.newUploadedIssueFeebackFile[i].errorMessagesFileFormat = "Invalid file format! Allowed file format is .pdf, .doc, .docx, .jpg, .jpeg, and .xlsx"
      }
    }

    this.newUploadedIssueFeebackFile.forEach(el => {
      if (!this.isError && (el?.errorMessagesFileSize || el?.errorMessagesFileFormat)) {
        this.isError = true;
        return;
      }
    })

  }

  getSelectedFiles() {
    for (let i = 0; i < this.selectedIssueFeedbackFiles.length; i++) {
      this.issueFeedbackFile = {
        id: this.fileId++,
        file: this.selectedIssueFeedbackFiles[i],
        fileName: this.selectedIssueFeedbackFiles[i].name,
        size: this.sharedService.FormatBytes(this.selectedIssueFeedbackFiles[i].size)
      };
      this.newUploadedIssueFeebackFile.push(this.issueFeedbackFile);
    }
  }

  deleteUploadFile(id) {
    const index = this.newUploadedIssueFeebackFile.findIndex(f => f.id == id);
    if (index > -1) {
      this.newUploadedIssueFeebackFile.splice(index, 1);
    }

    if (this.newUploadedIssueFeebackFile.length == 0) {
      this.selectedIssueFeedbackFiles = null;
      this.fileUploadValid = true;
    } else {
      this.errorMessagesFileFormat = [];
      this.GetValidFiles();
    }
  }

}
